import script from "./businessClient2.vue?vue&type=script&setup=true&lang=js"
export * from "./businessClient2.vue?vue&type=script&setup=true&lang=js"

import "./businessClient2.vue?vue&type=style&index=0&id=1ca68e9a&lang=css"

const __exports__ = script;

export default __exports__